document.addEventListener("click", function(e) {
    const btn = e.target.closest(".share-copy");
    if (!btn) return;

    const link = btn.dataset.link;
    navigator.clipboard.writeText(link).then(() => {
        btn.classList.add("copied");
        setTimeout(() => btn.classList.remove("copied"), 1500);
    });
});